//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Preloader from '~/components/other/Preloader'
import ProfileGallery from "~/components/profile/ProfileGallery";
import Button from "~/components/other/Button";
import LeftAside from '~/components/other/LeftAside'
import ProfileAvatar from "~/components/profile/ProfileAvatar";
import ProfileMenu from "~/components/profile/ProfileMenu";
import SidebarAnchors from "~/components/other/SidebarAnchors";
import CreateBtn from "~/components/gallery/personal/CreateBtn";
require("vue2-scrollbar/dist/style/vue2-scrollbar.css")
import { debounce } from '~/utils/utils';

export default {
  components: {
    Preloader,
    ProfileGallery,
    Button,
    CreateBtn,
    LeftAside,
    ProfileAvatar,
    ProfileMenu,
    SidebarAnchors
  },
  data(){
    return{
      tabletAnchors: false,
      buttonText: '',
      // collection: null,
      contentLoaded: false,
      needReload: false
    }
  },
  computed: {
    profileFullName () {
      const { name, surname } = this.collection.collectionOwner
      return `${name || ''} ${surname || ''}`
    },
    collection () {
      const data = this.getMyCollection?.data?.data
      return data ? data[0] : null
    }
  },
  beforeMount () {
    if (window) {
      this.mediaQuery = window.matchMedia('(max-width: 1180px)')

      this.mediaQuery?.addEventListener ? this.mediaQuery.addEventListener('change', this.mediaHandler) : this.mediaQuery.addListener(this.mediaHandler)

      if (this.mediaQuery.matches) {
        this.tabletAnchors = true
      }
    }
  },
  mounted() {
    const normal = this.$t('collectionPage.openMoreButtonText')
    const short = this.$t('collectionPage.openMoreButtonTextShort')
    if (window.innerWidth > 1599 || window.innerWidth <= 1180) {
      this.buttonText = normal
    } else {
      this.buttonText = short
    }
    window.addEventListener("resize", this.checkWindowWidth);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.checkWindowWidth);
  },
  methods: {
    checkWindowWidth: debounce(function() {
      const normal = this.$t('collectionPage.openMoreButtonText')
      const short = this.$t('collectionPage.openMoreButtonTextShort')
      if (window.innerWidth > 1599 || window.innerWidth <= 1180) {
        this.buttonText = normal
      } else {
        this.buttonText = short
      }
    }, 50),
    mediaHandler (e) {
      this.tabletAnchors = e.matches
    },
  },
  head() {
    const { shareParams } = this.$route.query

    let title = this.$i18n.locale === 'en' ? 'My Tretyakov' : 'Моя Третьяковка'
    let description = 'Стань патроном произведения и открой его для всего мира с Государственной Третьяковской галереей!'
    let image = []

    if (shareParams) {
      const { type, shareImg, n } = JSON.parse(shareParams)

      if (type === 'g') {
        description = this.getMyCollection?.data?.data?.name || this.$i18n.locale === 'en' ? 'My Collection' : 'Моя коллекция'
      } else if (type === 'p') {
        title = 'Теперь я патрон шедевра!'
      } else if (type === 'r') {
        title = `Я открыл шедевр` + (n || '')
      }

      if (shareImg) {
        image = [
          { hid: 'og:image-url', property: 'og:image:url', content: shareImg },
          { hid: 'og:image', property: 'og:image', content: shareImg }
        ]
      }
    }

    return {
      meta: [
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'og:description', property: 'og:description', content: description },
        ...image
      ]
    }
  },
  chimera: {
    getMyCollection () {
      const id = this.$router.currentRoute.params.id
      if (!id) {
        this.$router.push('/')
        return
      }
      return {
        url: '/api/v1/collection/get/',
        key: `get-collection-${id}`,
        auto: true,
        prefetch: false,
        params: {
          userId: id,
          lang: this.$i18n.locale || 'ru'
        },
        on: {
          success () {
            if (!this.getMyCollection.data.data) {
              this.$nuxt.error({ statusCode: 404 })
              // this.$router.push('/')
            }
          }
        }
      }
    }
  }
}
